var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentGeneralCountryofpref(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.038,
    height: 33.929,
    viewBox: "0 0 39.038 33.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "world_1_",
    "data-name": "world (1)",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43858",
    "data-name": "Path 43858",
    d: "M483.328,85.62a.594.594,0,0,1-.594-.594v-6a.594.594,0,1,1,1.187,0v6A.594.594,0,0,1,483.328,85.62Zm0,0",
    transform: "translate(-445.927 -72.45)",
    fill: "#c2c7cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40094",
    "data-name": "Group 40094",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43859",
    "data-name": "Path 43859",
    d: "M82.047,159.376a14.1,14.1,0,0,1-13.119-19.264L82.047,135.8l13.119,4.311a14.1,14.1,0,0,1-13.119,19.264Zm0,0",
    transform: "translate(-62.769 -125.447)",
    fill: "#8ebfe8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43860",
    "data-name": "Path 43860",
    d: "M260.979,192.336c1.324,4.342,1.509,6.466-4.951,8.11-2.806.714-3.32,4.738-2.348,6.435,1.355,2.364,5.236,3.3,9.437.643a14.107,14.107,0,0,0,3.2-15.187Zm0,0",
    transform: "translate(-233.921 -177.671)",
    fill: "#8bc34a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43861",
    "data-name": "Path 43861",
    d: "M74.987,249.172c3.1.627,3.589,6.791-.583,7.011a14.079,14.079,0,0,1-6.455-11.845q0-.647.056-1.277C72.771,242.6,68.386,247.833,74.987,249.172Zm0,0",
    transform: "translate(-62.769 -224.503)",
    fill: "#8bc34a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43862",
    "data-name": "Path 43862",
    d: "M80.793,103.89h26.236v-7.3l-10.458,2.5a11.082,11.082,0,0,1-2.659.485,11.075,11.075,0,0,1-2.661-.485l-10.458-2.5Zm0,0",
    transform: "translate(-74.633 -89.225)",
    fill: "#546e7a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43863",
    "data-name": "Path 43863",
    d: "M470.706,157.738a1.662,1.662,0,0,0-1.635,1.677v2.636a1.637,1.637,0,1,0,3.273,0v-2.636A1.662,1.662,0,0,0,470.706,157.738Zm0,0",
    transform: "translate(-433.306 -145.711)",
    fill: "#ffd54f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43864",
    "data-name": "Path 43864",
    d: "M479.781,157.965a1.688,1.688,0,0,1,.819,1.453v2.633a1.685,1.685,0,0,1-.816,1.45,1.588,1.588,0,0,0,.816.227,1.662,1.662,0,0,0,1.638-1.677v-2.636a1.662,1.662,0,0,0-1.638-1.677A1.6,1.6,0,0,0,479.781,157.965Zm0,0",
    transform: "translate(-443.2 -145.711)",
    fill: "#e6a235",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43865",
    "data-name": "Path 43865",
    d: "M107.029,96.59l-10.458,2.5a11.086,11.086,0,0,1-2.659.485,11.078,11.078,0,0,1-2.661-.485l-10.458-2.5v2.687l.449.109,10.46,2.5a11.036,11.036,0,0,0,2.659.482,11.048,11.048,0,0,0,2.661-.482l5.351-1.281c1.6-.385,1.448.819,1.448,2.373v.907h3.209Zm0,0",
    transform: "translate(-74.633 -89.225)",
    fill: "#37474f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43866",
    "data-name": "Path 43866",
    d: "M6.161,8.165l10.458,2.5a10.97,10.97,0,0,0,2.661.485,10.977,10.977,0,0,0,2.659-.485L32.4,8.165l5-1.2a1.325,1.325,0,0,0,1.153-1.39A1.328,1.328,0,0,0,37.4,4.186L21.939.483A11.054,11.054,0,0,0,19.28,0a11.047,11.047,0,0,0-2.661.483L1.157,4.186A1.329,1.329,0,0,0,0,5.576a1.326,1.326,0,0,0,1.152,1.39Zm0,0",
    transform: "translate(-0.001 0)",
    fill: "#7c8c94",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43867",
    "data-name": "Path 43867",
    d: "M362.955,24.343,352.426,21.82a8.009,8.009,0,0,1,1.34,4.386,7.669,7.669,0,0,1-.387,2.409,7.987,7.987,0,0,1-.347.885l4.92-1.179,5-1.2a1.415,1.415,0,0,0,0-2.78Zm0,0",
    transform: "translate(-325.555 -20.157)",
    fill: "#546e7a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43868",
    "data-name": "Path 43868",
    d: "M170.17,391.527c-2.908,1.841-5.665,1.957-7.534,1.07a13.18,13.18,0,0,1-10.026.759,14.106,14.106,0,0,0,17.56-1.828Zm0,0",
    transform: "translate(-140.974 -361.675)",
    fill: "#519ad6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43869",
    "data-name": "Path 43869",
    d: "M284.109,208.593c1.869.888,4.626.772,7.534-1.07a14.052,14.052,0,0,0,4.181-10.016,14.229,14.229,0,0,0-.078-1.481,13.906,13.906,0,0,0-.9-3.69h-3.206C293.784,199.049,289.908,205.753,284.109,208.593Zm0,0",
    transform: "translate(-262.447 -177.671)",
    fill: "#689f38",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentGeneralCountryofpref);
export default __webpack_public_path__ + "static/media/student-general-countryofpref.7ff14b6eaf633027c1e595fcf4e959f3.svg";
export { ForwardRef as ReactComponent };